/**
 * Creates and inserts a promotions sidebar element.
 *
 * @param {Object} options
 * @param {string} options.imageUrl       - URL of the promo image
 * @param {string} options.imageAlt       - Alt text for the image
 * @param {string} options.title          - Promo card title
 * @param {string} options.description    - Promo card description
 * @param {string} options.currentPrice   - Discounted price (e.g. "$29.99")
 * @param {string} options.originalPrice  - Original price (e.g. "$49.99")
 * @param {string} options.buttonText        - Call-to-action button label
 * @param {string} options.ctaUrl         - Call-to-action link URL
 * @param {string} options.badge          - Badge label (e.g. "NEW")
 * @param {string} options.footnote       - Small text below the card
 * @param {string|Element} options.target - CSS selector or DOM element to append into
 */
function createPromotion(options = {}) {
  const {
    imageUrl = '',
    imageLink = '',
    imageAlt = 'Promotion',
    title = '',
    description = '',
    currentPrice = '',
    originalPrice = '',
    buttonText = '',
    buttonUrl = '',
    badge = '',
    footnote = '',
    target = '',
  } = options;
console.log(options)
  const section = document.createElement('div');
  section.className = 'promotions-section';

  section.innerHTML = `
    ${title ? 
      `<div class="promotions-header">
        <div class="promotions-title headingLg mc-community-show__nav-section-heading">Featured</div>
        ${badge ? `<div class="promotions-badge">${badge}</div>` : ''}
      </div>` : ''
    }

    <div class="promo-card">
      ${imageLink ? `<a href="${imageLink}" target="_blank">` : ''}
      ${imageUrl ? `<img class="promo-card__image" src="${imageUrl}" alt="${imageAlt}" />` : ''}
      ${imageLink ? `</a>` : ''}
      ${description ? `<div class="promo-card__body">` : ''}
        ${title ? `<p class="promo-card__title">${title}</p>` : ''}
        ${description ? `<p class="promo-card__description">${description}</p>` : ''}
        ${currentPrice || originalPrice ? `
          <div class="promo-card__pricing">
            ${currentPrice ? `<div class="promo-card__price--current">${currentPrice}</div>` : ''}
            ${originalPrice ? `<div class="promo-card__price--original">${originalPrice}</div>` : ''}
          </div>
        ` : ''}
        ${buttonUrl && buttonText ? `<a href="${buttonUrl}" class="promo-card__cta">${buttonText}</a>` : ''}
      ${description ? `</div` : ''}
    </div>

    ${footnote ? `<p class="promotions-footnote">${footnote}</p>` : ''}
  `;

  const container = typeof target === 'string'
    ? document.querySelector(target)
    : target;

  if (!container) {
    console.warn(`createPromotion: target "${target}" not found in DOM.`);
    return null;
  }

  container.appendChild(section);
  return section;
}
